export const ADD         = "ADD"
export const MODYFIKACJA = "MODYFIKACJA"
export const KASOWANIE   = "KASOWANIE"